import React, { FC } from "react";
import { IconType } from "./types";
import { COLOR_BLACK } from "../colors";

export const WidgetsIcon: FC<IconType> = ({ color = COLOR_BLACK }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M16.0001 5.1757L18.8301 8.0057L16.0001 10.8357L13.1701 8.0057L16.0001 5.1757ZM8.34009 5.6557V9.6557H4.34009V5.6557H8.34009ZM18.3401 15.6557V19.6557H14.3401V15.6557H18.3401ZM8.34009 15.6557V19.6557H4.34009V15.6557H8.34009ZM16.0001 2.3457L10.3401 7.9957L16.0001 13.6557L21.6601 7.9957L16.0001 2.3457ZM10.3401 3.6557H2.34009V11.6557H10.3401V3.6557ZM20.3401 13.6557H12.3401V21.6557H20.3401V13.6557ZM10.3401 13.6557H2.34009V21.6557H10.3401V13.6557Z"
      fill={color}
    />
  </svg>
);
